import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import FormGroup from "react-bootstrap/lib/FormGroup";
import FormControl from "react-bootstrap/lib/FormControl";
import InputGroup from "react-bootstrap/lib/InputGroup";
import { compose } from "react-apollo";

import Link from "../../Link/Link";
import Loader from "../../Loader";
import CountryList from "../../CountryList";
import CustomCheckbox from "../../CustomCheckbox/CustomCheckbox";

import { sendVerificationSms } from "../../../actions/SmsVerification/sendVerificationSms";
import { openSmsVerificationModal } from "../../../actions/SmsVerification/modalActions";

import messages from "../../../locale/messages";
import showToaster from "../../../helpers/showToaster";

import s from "./AddPhoneNumberForm.css";
import bt from "../../../components/commonStyle.css";

class AddPhoneNumberForm extends Component {
  static propTypes = {
    fieldType: PropTypes.string,
    formatMessage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      countryCode: "AU",
      country: "+61",
      phoneNumber: "",
      submitting: false,
      error: null,
      isAgreePhoneNumberVerification: false,
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    const { error } = this.state;

    let updatedError = { ...error };

    // Update the phoneNumber field
    this.setState({ [name]: value }, () => {
      if (name === "phoneNumber") {
        const isValid = this.validateAustralianPhoneNumber(value);

        if (!value) {
          updatedError.phoneNumber = "required";
        } else if (!isValid) {
          updatedError.phoneNumber = "invalidAustralianNumber";
        } else {
          // ✅ Clear error when valid input
          delete updatedError.phoneNumber;
        }

        this.setState({ error: updatedError });
      }
    });
  };

  validateAustralianPhoneNumber = (number) => {
    const cleaned = number.replace(/[^\d+]/g, "");

    // Remove leading '+' for uniformity
    const phone = cleaned.startsWith("+") ? cleaned.slice(1) : cleaned;

    // Handle country code and local formats
    const regex = /^(61|0)?(2|3|4|7|8)\d{8}$/;

    return regex.test(phone);
  };
  submitForm = async () => {
    const { sendVerificationSms } = this.props;
    const {
      country,
      phoneNumber,
      countryCode,
      isAgreePhoneNumberVerification,
    } = this.state;

    const isValidAustralianNumber =
      this.validateAustralianPhoneNumber(phoneNumber);
    // const cleanedPhone = phoneNumber.replace(/[\s-]/g, '');
    // const isValidAustralianNumber = /^(\+?61|0)4\d{8}$/.test(cleanedPhone);

    let error = null,
      submitting = false;

    if (!phoneNumber) {
      error = { phoneNumber: "required" };
    } else if (!this.validateAustralianPhoneNumber(phoneNumber)) {
      error = { phoneNumber: "invalidAustralianNumber" };
    }

    // if (!phoneNumber) {
    //   error = { phoneNumber: 'required' };
    // } else if (isNaN(phoneNumber)) {
    //   error = { phoneNumber: 'required' };
    // } else if (!isValidAustralianNumber) {
    //   error = { phoneNumber: 'Invalid Australian number format' };
    // }

    if (!isAgreePhoneNumberVerification && error === null) {
      showToaster({
        messageId: "isAgreePhoneNumberError",
        toasterType: "error",
      });
      return;
    }
    submitting =
      error === null && isAgreePhoneNumberVerification ? true : false;

    this.setState({ submitting, error });

    if (error === null && submitting) {
      const { status, errorMessage } = await sendVerificationSms(
        country,
        phoneNumber,
        countryCode
      );

      if (status != "200") {
        if (errorMessage == "Authenticate") {
          error = { phoneNumber: "twilioAuthErr" };
        } else {
          error = {
            phoneNumber: errorMessage
              ? errorMessage
              : "Sorry, something went wrong. Please try again",
          };
        }
      }
    }
    if (this.refs.addPhoneNumberForm) {
      this.setState({ submitting: false, error });
    }
  };

  handleCountryChange = (e, selectedData) => {
    this.setState({
      country: selectedData.dialCode,
      countryCode: selectedData.countryCode,
    });
  };

  render() {
    const { formatMessage } = this.props.intl;
    const {
      country,
      phoneNumber,
      submitting,
      error,
      countryCode,
      isAgreePhoneNumberVerification,
    } = this.state;
    const { siteName } = this.props;

    return (
      <div className={s.formContainer} ref="addPhoneNumberForm">
        <FormGroup className={s.formGroup}>
          <label className={cx(s.labelText, "textWhite")}>
            <FormattedMessage {...messages.chooseACountry} />
          </label>
          <FormControl
            value="Australia"
            readOnly
            className={cx(bt.commonControlInput)}
          />
          {/* <CountryList
            input={
              {
                name: 'countryCode',
                onChange: this.handleChange,
                value: countryCode
              }
            }
            className={cx(bt.commonControlSelect)}
            dialCode={false}
            getSelected={this.handleCountryChange}
          /> */}
        </FormGroup>

        <FormGroup className={s.formGroup}>
          <label className={cx(s.labelText, "textWhite")}>
            <FormattedMessage {...messages.addAPhoneNumber} />
          </label>
          <InputGroup>
            <InputGroup.Addon className={s.inputGroupAddon}>
              {country}
            </InputGroup.Addon>
            <FormControl
              name={"phoneNumber"}
              value={phoneNumber || ""}
              placeholder={""}
              type={"text"}
              className={cx(bt.commonControlInput)}
              onChange={this.handleChange}
              onInput={(e) => {
                const cleaned = e.target.value.replace(/[^\d]/g, ""); // only digits
                e.target.value = cleaned;

                // sync with your handler if needed
                this.setState({ phoneNumber: cleaned }, () => {
                  const { error } = this.state;
                  let updatedError = { ...error };

                  if (!cleaned) {
                    updatedError.phoneNumber = "required";
                  } else if (!this.validateAustralianPhoneNumber(cleaned)) {
                    updatedError.phoneNumber = "invalidAustralianNumber";
                  } else {
                    delete updatedError.phoneNumber;
                  }

                  this.setState({ error: updatedError });
                });
              }}
            />
          </InputGroup>
          {error && error.phoneNumber && (
            <span className={s.errorMessage}>
              {messages[error.phoneNumber]
                ? formatMessage(messages[error.phoneNumber])
                : error.phoneNumber}
            </span>
          )}
        </FormGroup>

        <div className={cx(s.phoneNumberCheckBox, bt.space3)}>
          <CustomCheckbox
            className={"icheckbox_square-green flexNoShrink"}
            name={"isAgreePhoneNumberVerification"}
            checked={isAgreePhoneNumberVerification}
            onChange={(e) => {
              this.setState({ isAgreePhoneNumberVerification: e });
            }}
          />
          <p className={s.indicationTxt}>
            {formatMessage(messages.phoneNumberVerificationInfo1)} {siteName}{" "}
            {formatMessage(messages.phoneNumberVerificationInfo2)}{" "}
            <a href="/privacy" target="_blank">
              {formatMessage(messages.termsAndPrivacy)}
            </a>
          </p>
        </div>

        <FormGroup className={cx(s.formGroup, "textAlignEnd", bt.noMargin)}>
          <Loader
            type={"button"}
            buttonType={"button"}
            className={cx(
              s.button,
              bt.btnPrimary,
              bt.btnLarge,
              "arButtonLoader"
            )}
            disabled={submitting}
            show={submitting}
            label={formatMessage(messages.verifyViaSms)}
            handleClick={this.submitForm}
          />
        </FormGroup>
      </div>
    );
  }
}

const mapState = (state) => ({
  profileId: state.account.data.profileId,
  siteName: state.siteSettings.data.siteName,
});

const mapDispatch = {
  sendVerificationSms,
  openSmsVerificationModal,
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch)
)(AddPhoneNumberForm);
